import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-cosigner',
  templateUrl: './cosigner.component.html'
})
export class CosignerComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() coSolicitante: any;

  showCoSigner = false;
  public form: FormGroup;

  constructor(private fb: FormBuilder) { }
  

  

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      ss: ['', [Validators.required]],
      licence: ['', [Validators.required]],
      birthDate: ['', [Validators.required]]
    });
    this.formReady.emit(this.form);
    if(this.coSolicitante){
      this.form.patchValue(this.coSolicitante);
      if(this.coSolicitante.name.length > 2 ){
        let radioBtn:any = document.querySelector('#hasCosignerSi');
        radioBtn.checked = true;
        this.showCoSigner = true;
      } else{
        let radioBtn:any = document.querySelector('#hasCosignerNo');
        radioBtn.checked = true;
        this.showCoSigner = false;
      }
    }
  }

  coSigner(value:any){
    if(value.target.value== "si"){
      // this.form.setValidators(Validators.required);
      // let controls = this.form.controls;
      // for (let name in controls) {
      //     this.form.get(name)?.setValidators(Validators.required);
      // }
      this.showCoSigner = true;
    }else{
      this.form.clearValidators();
      // let controls = this.form.controls;
      // for (let name in controls) {
      //     this.form.get(name)?.clearValidators();
      // }
      this.showCoSigner = false;
    }
  }

  addChildForm(name: string, group: FormGroup) {
    this.form.addControl(name, group);
  }

}
